import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "user-layout" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = { class: "ant-dropdown-link" }

import { useRouter, useRoute } from "vue-router";
import { h, ref, watch } from "vue";
import {
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  MailOutlined,
} from "@ant-design/icons-vue";
import { MenuProps, message } from "ant-design-vue";
import { usersLogout } from "@/api/user";
// 导航链接
// 实例

export default /*@__PURE__*/_defineComponent({
  __name: 'UserLayout',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const current = ref<string[]>(["/user/userHome"]);

//点击菜单跳转
const doMenuClick = ({ key }: { key: string }) => {
  router.push({
    path: key,
  });
};

const userLogout = async () => {
  const res = await usersLogout(null);
  if (res && res.data) {
    message.success("登出成功!");
    router.push({
      path: "/user-login",
      replace: true,
    });
    return null;
  }
  message.error("登出异常！");
};

//刷新时高亮问题
watch(
  () => route.path,
  (newPath) => {
    // 将当前路径赋值给 current
    current.value = [newPath];
  },
  { immediate: true } // 关键配置：初始化时立即执行一次，解决刷新不高亮的问题
);

const items = ref<MenuProps["items"]>([
  {
    key: "/user/userHome",
    icon: () => h(UserOutlined),
    label: "个人主页",
    title: "个人主页",
  },
  {
    key: "/user/userTaskPool",
    icon: () => h(AppstoreOutlined),
    label: "任务池",
    title: "任务池",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { style: {"flex-wrap":"nowrap"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  flex: "250px",
                  style: {"display":"flex","justify-content":"center","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_router_link, { to: "/user/userHome" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            class: "logo",
                            src: _imports_0,
                            alt: "logo"
                          }, null, -1),
                          _createElementVNode("div", { class: "title" }, "个人用户中心", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  flex: "auto",
                  style: {"display":"flex","justify-content":"center","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu, {
                      selectedKeys: current.value,
                      "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
                      mode: "horizontal",
                      items: items.value,
                      onClick: doMenuClick
                    }, null, 8, ["selectedKeys", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  flex: "250px",
                  style: {"display":"flex","justify-content":"right","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_divider),
                            _createVNode(_component_a_menu_item, {
                              key: "1",
                              style: {"display":"flex","justify-content":"center","align-items":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: "/user-login",
                                  onClick: userLogout
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(LogoutOutlined)),
                                    _cache[2] || (_cache[2] = _createTextVNode(" 退出登录", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_divider),
                            _createVNode(_component_a_menu_item, {
                              key: "2",
                              disabled: "",
                              style: {"display":"flex","justify-content":"center","align-items":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, { to: "/user-login" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MailOutlined)),
                                    _cache[3] || (_cache[3] = _createTextVNode(" 消息中心", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_divider),
                            _createVNode(_component_a_menu_item, {
                              key: "3",
                              disabled: "",
                              style: {"display":"flex","justify-content":"center","align-items":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, { to: "/user-login" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(UserDeleteOutlined)),
                                    _cache[4] || (_cache[4] = _createTextVNode(" 用户注销", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_3, [
                          _createVNode(_component_a_avatar, { size: 48 }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(UserOutlined))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})